import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { ScrollingService } from 'src/app/services/scrolling.service';

import { Brand, PartnerType } from '../../../../models/brand.interface';
import { CompatibilityService } from '../../../../services/compatibility.service';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingComponent } from '../../../../../../../../shared/components/loading/loading.component';
import { BrandItemComponent } from '../brand-item/brand-item.component';
import {
  NgClass,
  AsyncPipe,
  UpperCasePipe,
  TitleCasePipe,
} from '@angular/common';
import { LazyImageDirective } from '../../../../../../../../directive/lazyImage.directive';
import { CompatibilityCardComponent } from '../../../shared/compatibility-card/compatibility-card.component';

@Component({
  selector: 'app-brand-selection',
  templateUrl: './brand-selection.component.html',
  styleUrls: ['./brand-selection.component.scss'],
  standalone: true,
  imports: [
    CompatibilityCardComponent,
    LazyImageDirective,
    NgClass,
    BrandItemComponent,
    LoadingComponent,
    AsyncPipe,
    UpperCasePipe,
    TitleCasePipe,
    TranslateModule,
  ],
})
export class BrandSelectionComponent {
  brands$: Observable<Brand[]> = this.compatibilityService.filteredBrands$;
  selectedFilter$: Observable<string> =
    this.compatibilityService.selectedFilter$;
  nextFilter$: Observable<string> = this.compatibilityService.nextFilter$;
  nextBrands$: Observable<Brand[]> = this.compatibilityService.nextBrands$;
  selectedBrand$: Observable<Brand | null> =
    this.compatibilityService.selectedBrand$;
  isLoadingBrands$: Observable<boolean> =
    this.compatibilityService.isLoadingBrands$;
  filters: string[] = [...this.compatibilityService.alphabet, '0-9', 'PARTNER'];
  PartnerType = PartnerType;

  goldBrandPartner$: Observable<Brand[] | null> =
    this.compatibilityService.goldBrandPartner$;
  silverBrandPartner$: Observable<Brand[] | null> =
    this.compatibilityService.silverBrandPartner$;
  bronzeBrandPartner$: Observable<Brand[] | null> =
    this.compatibilityService.bronzeBrandPartner$;

  constructor(
    private compatibilityService: CompatibilityService,
    private scrollingService: ScrollingService
  ) { }

  onFilterBrands(char: string): void {
    this.compatibilityService.selectFilters(char);
    this.scrollingService.detectChangesAndScrollSmoothlyTo('brandSelection');
  }

  onClickBrand(brandId: number): void {
    this.compatibilityService.selectBrand(brandId);
  }
}
